import { useAppMode } from "@/contexts/AppModeContext";
import { canEditRecipesInMode } from "@/lib/app-mode";

/**
 * Whether the current mode allows creating, editing or deleting recipes
 * (YC-33): Build mode only, whatever the role. Combine it with the user's
 * permission — it never replaces one.
 */
export function useCanEditRecipes(): boolean {
  const { mode } = useAppMode();
  return canEditRecipesInMode(mode);
}
